// eslint-disable-next-line import/no-internal-modules
import type MaskedPattern from 'imask/esm/masked/pattern';
import * as React from 'react';
import { IMaskInput } from 'react-imask';

export type MaskProps = React.ComponentProps<typeof IMaskInput>['mask'];
type BlocksProps = MaskedPattern['blocks'];
type Definitions = MaskedPattern['definitions'];

export interface TextMaskProps {
    mask?: MaskProps;
    blocks?: BlocksProps;
    definitions?: Definitions;
    thousandsSeparator?: string;
    radix?: string;
    min?: number;
    max?: number;
    scale?: number;
    padFractionalZeros?: boolean;
    normalizeZeros?: boolean;
    lazy?: boolean;
    expose?: boolean;
    mapToRadix?: string[];
    value?: string;
    keepMask?: boolean;
}

interface InnerTextMaskProps extends TextMaskProps {
    name?: string;
    onChange?: React.FormEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}

export const TextMask = React.forwardRef<HTMLInputElement, InnerTextMaskProps>(
    (props, ref) => {
        const { onChange, mask, keepMask, ...inputProps } = props;

        return (
            <IMaskInput
                inputRef={ref}
                mask={mask as MaskedPattern['mask']}
                lazy={false}
                {...inputProps}
                unmask={!keepMask}
                onAccept={(value) => {
                    if (value === inputProps.value) {
                        return;
                    }
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    onChange?.({
                        target: { value }
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } as any);
                }}
            />
        );
    }
);
